import { AccountState } from '../../models/loyalty/account.state';
import {
  AccountActions,
  GET_ACCOUNT,
  GET_ACCOUNT_ERROR,
  GET_ACCOUNT_SUCCESS
} from '../../actions/loyalty/actions-account';

/* eslint-disable */
function getInitialState(): AccountState {
  return {
    agentNumber: 0,
    isLoading: false,
    loadingError: ''
  };
}

const initialState: AccountState = getInitialState();

/* eslint-disable */
export function reducersAccount(state = initialState, action: AccountActions): AccountState {
  switch (action.type) {
    case GET_ACCOUNT:
      return { ...state, isLoading: true, loadingError: '' };
    case GET_ACCOUNT_SUCCESS:
      return { ...state, agentNumber: action.payload, isLoading: false, loadingError: '' };
    case GET_ACCOUNT_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };
    default:
      return state;
  }
}
